<template>
  <div id="manage">
    <div class="content">
        <div class="title"><span style="color:#c30d23;cursor:pointer;" @click="goback(1)">{{term_name}}</span>  /  班级管理</div>
       
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="searchModel.keyword" 
                        icon="ios-search" 
                        placeholder="承办单位名称搜索" 
                        style="width: 330px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="getClassList(1)" 
                        @keyup.enter.native="getClassList(1)" 
                        autocomplete="off"></Input>
                        <Select v-model="searchModel.dance_id" clearable placeholder="请选择舞种" class="borDiv" style="width:150px;border:1px solid #e7e7eb;margin:20px 10px;" @on-change="getClassList(1)">
                            <Option v-for="item in danceList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                        </Select>
                        <Select v-model="searchModel.level_id" clearable placeholder="请选择级别" class="borDiv" style="width:150px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="getClassList(1)">
                            <Option v-for="item in levelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <Select v-model="searchModel.status"  clearable placeholder="请选择状态" class="borDiv" style="width:150px;border:1px solid #e7e7eb;margin:20px 0 20px 10px;" @on-change="getClassList(1)">
                            <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="addClass">新增班级</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">班级名称</div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入班级名称" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">舞种</div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.dance_id" class="bordiv" placeholder="请选择舞种" filterable @on-change="getLvel(1)" style="width:440px;">
                                 <Option v-for="item in danceList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">最低级别</div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.min_level" class="bordiv" placeholder="请选择最低级别" filterable style="width:440px;">
                                    <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select> 
                                
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">最高级别</div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.max_level" class="bordiv" placeholder="请选择最高级别" filterable style="width:440px;">
                                    <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select> 
                                
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">承办单位</div>
                            <div class="fl_left inputBox">
                                <Select v-model="addModel.company_id" class="bordiv" placeholder="请选择承办单位" filterable style="width:440px;" @on-change="companyChange">
                                 <Option v-for="item in companyList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad" v-if="is_pay==1">
                            <div class="fl_left name">报名金额</div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.price" class="bordiv" size="large" autocomplete="off" style="width:440px;" @input="addModel.price=addModel.price.replace(/[^\d(?:\.\d{1,2})?$]/g,'')" placeholder="请输入报名金额" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">上课日期</div>
                            <div class="fl_left inputBox" style="height: 36px;">
                                <DatePicker 
                                type="daterange" 
                                format="yyyy-MM-dd" 
                                placeholder="请选择上课日期"
                                class="bordiv" 
                                style="width:440px;"
                                :value="classDate"
                                @on-change="dateChange1"
                                :options="options3"
                                >
                                </DatePicker>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">最多申报人数</div>
                            <div class="fl_left inputBox">
                                <Input v-model="addModel.max_num" class="bordiv" size="large" style="width:440px;" placeholder="请输入" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="saveClass">确定</div>
                </div>
            </div>
            <div class="alertBox" v-if="teaShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置</div>
                        <div class="fl_right tandel" @click="teadel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">高教</div>
                            <div class="fl_left inputBox">
                                <Select v-model="teacher_id" class="bordiv" placeholder="请选择高教" filterable style="width:440px;">
                                 <Option v-for="item in teaList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="teayes">确定</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    status:'',
                    dance_id:'',
                    level_id:'',
                    keyword:'',
                    page:1,
                    term_id:'',
                },
                //添加model
                addModel:{
                    class_id:'',
                    term_id:'',
                    name:'',
                    dance_id:'',
                    min_level:'',
                    max_level:'',
                    max_num:'',
                    company_id:'',
                    start_date:'',
                    end_date:'',
                    price:'',
                },
                teaShow:false,
                teaList:'',
                items:[
                    {
                        name:'报名培训中',
                        type:0
                    },
                    {
                        name:'已结束',
                        type:1
                    },
                ],
                start_date:'',
                end_date:'',
                statusList:[],
                classDate:[],
                companyList:[],
                options3:{},
                levelArr:[],
                levelList:[],
                danceList:[],
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '上课时间',
                        align: 'center',
                        key: 'date_show',
                    },
                    {
                        title: '舞种',
                        align: 'center',
                        key: 'dance_name',
                    },
                    {
                        title: '级别',
                        align: 'center',
                        key: 'level',
                        render: (h, params) => {
                            if(params.row.status==1||params.row.status==0){
                                return h('div',[
                                    h('div',{
                                        // style:{
                                        //     color:'#999',
                                        // }
                                    },params.row.level),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                if(params.row.status==1){
                                                    this.$Modal.success({
                                                        title: '扫描二维码入班',
                                                        render: (h) => {
                                                            return h('div',[
                                                                h('Img', {
                                                                    attrs: {
                                                                        src:params.row.qrcode,
                                                                    },
                                                                    style:{
                                                                        border:'1px solid #dcdcdc',
                                                                        width:'200px',
                                                                        display:'block',
                                                                        margin:'0 auto'
                                                                    },
                                                                    on: {
                                                                    }
                                                                }),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'center',
                                                                        lineHeight:'50px'
                                                                    },
                                                                },this.term_name+params.row.name),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'left',
                                                                        // marginBottom:'100px'
                                                                    },
                                                                },[
                                                                    h('div',{
                                                                        style:{
                                                                            padding:'8px 10px',
                                                                            border:'1px solid #dcdcdc',
                                                                            borderRadius:'4px',
                                                                            backgroundColor:'#e3e3e5',
                                                                            margin:'0 auto',
                                                                            cursor:'pointer',
                                                                            width:'100px',
                                                                            textAlign:'center'
                                                                        },
                                                                        on: {
                                                                            click: () => {
                                                                                let _this=this;
                                                                                _this.CopyUrl()
                                                                            }
                                                                        }
                                                                    },'复制网址'),
                                                                    h('a',{
                                                                        style:{
                                                                            color:'#1890ff',
                                                                            width:'260px',
                                                                            wordBreak:'break-word',
                                                                            float:'left',
                                                                            opacity:'0'
                                                                        },
                                                                        attrs:{
                                                                            href:params.row.jump_url,
                                                                            target:'_blank',
                                                                            id:'inviteCode'
                                                                        }
                                                                    },params.row.jump_url),
                                                                ])
                                                            ])
                                                        },
                                                        onOk: () => {
                                                            
                                                        },
                                                        onCancel: () => {
                                                            // this.getClassList(0)
                                                        }
                                                    })
                                                }
                                                else{
                                                    this.$Modal.confirm({
                                                        title: '提示',
                                                        content: '<p>确定要开启该班级?</p>',
                                                        okText: '确定',
                                                        cancelText: '取消',
                                                        onOk: () => {
                                                            _this.$axios.post('changeenrollstatus',{
                                                                class_id:params.row.id
                                                            }).then(res=>{
                                                                if(res.data.code==200){
                                                                    _this.$Message.success('操作成功');
                                                                    _this.getClassList(0);
                                                                 }
                                                                 else{
                                                                     this.$Message.error(res.data.message);
                                                                 }
                                                            }).catch(function (error) {
                                                              console.log(error);
                                                            });
                                                        },
                                                        onCancel: () => {
                                                            // this.$Message.info('取消');
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }, '报名二维码'),
                                ]);
                            }
                            else{
                                return h('div',params.row.level)
                            }
                        }
                    },
                    {
                        title: '报名学员',
                        align: 'center',
                        key:'max_num',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                localStorage.setItem("searchData"+this.searchModel.term_id, JSON.stringify(this.searchModel));
                                                this.$router.push({
                                                    path:'/manager/teacher/class/ban/stulist',
                                                    query:{
                                                        class_id:params.row.id,
                                                        name:params.row.name,
                                                        term_name:this.term_name,
                                                    }
                                                })
                                            }
                                        }
                                    }, params.row.cur_num+'/'+params.row.max_num),
                                ]);
                            // }
                        }
                    },
                    {
                        title: '承办单位',
                        align: 'center',
                        key: 'company_name',
                        width:220,
                    },
                    
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div',{
                                    style:{
                                        color:'#49c00e',
                                    }
                                },'报名中');
                            }
                            else if(params.row.status==0){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'未开启报名');
                            }
                            else if(params.row.status==2){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'已结束');
                            }
                        }
                    },
                    {
                        title: '高教',
                        align: 'center',
                        key: 'phone',
                        render: (h, params) => {
                            if(this.tabId==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.dance_id=params.row.dance_id;
                                                _this.class_id=params.row.id;
                                                _this.teacher_id=params.row.teacher_id;
                                                _this.teaShow=true;
                                                _this.getTea();
                                            }
                                        }
                                    }, params.row.teacher_name==''?'点击设置':params.row.teacher_name),
                                ]);
                            }
                            else{
                                return h('div',params.row.teacher_name)
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            margin:'0 5px',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                let str=params.row.status==1?'关闭':'开启';
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要'+str+'该班级?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('changeenrollstatus',{
                                                            class_id:params.row.id
                                                        }).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('操作成功');
                                                                _this.getClassList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, params.row.status==1?'关闭报名':'开启报名'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.addModel = JSON.parse(JSON.stringify(params.row));
                                                _this.addModel.class_id = params.row.id;
                                                
                                                _this.classDate=[params.row.start_date,params.row.end_date];
                                                _this.options3={
                                                    disabledDate (date){
                                                        return (date && date.valueOf() > new Date(_this.addModel.end_date).getTime()) || (date && date.valueOf() < new Date(_this.addModel.start_date).getTime() - 86400000);
                                                    }
                                                }
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, this.tabId==0?'编辑':''),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个班级?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deleteclass',{class_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                this.getClassList(0)
                                                                this.$Message.success('删除成功');
                                                            }
                                                            else{
                                                                this.$Message.error(res.data.message);
                                                            }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    },
                    {
                        title: '导出',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                               
                                                _this.$axios.post('getuploaduserimgurl',{class_id:params.row.id}).then(res=>{
                                                    if(res.data.code==200){
                                                        window.open(res.data.data);
                                                    }else{
                                                        _this.$Message.error(res.data.message);
                                                    }
                                                }).catch(function (error) {
                                                  console.log(error);
                                                });
                                            }
                                        }
                                    }, '证件照下载'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要导出该班级的名单汇总表?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('getuploadclassuserurl',{class_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                window.open(res.data.data);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '名单汇总表'),
                                ]);
                            // }
                        }
                    },
                ],
                data6: [],
                alertShow:false,
                valm:0,
                num:0,
                tabId:0,
                term_name:'',
                is_pay:'',
            }
        },
        methods:{
            companyChange(value){
                for (var i = 0;i<this.companyList.length;i++) {
                   if(this.companyList[i].id==value) {
                        this.is_pay=this.companyList[i].is_pay;
                   }
                }
            },
            CopyUrl(data){
                var Url2 = document.getElementById("inviteCode").innerText;
                var oInput = document.createElement("input");
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = "oInput";
                oInput.style.display = "none";
                this.$Message.success('复制成功！');
            },
            goback(index){
                if(index==1){
                    this.$router.go(-1);
                }
                if(index==2){
                    this.$router.go(-2);
                }
            },
            dateChange1(value){
                this.classDate=value;
            },
            teayes(){
                let _this=this;
                _this.$axios.post('setteacher',{
                    teacher_id:_this.teacher_id,
                    class_id:_this.class_id,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.teaShow=false;
                        _this.getClassList(0);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
                
            },
            teadel(){
                this.teaShow=false;
            },
            saveClass(){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.addModel.name==''){
                    this.$Message.error('请输入班级名称');
                }
                else if(_this.addModel.dance_id===''){
                    this.$Message.error('请选择舞种');
                }
                else if(_this.addModel.min_level===''){
                    this.$Message.error('请选择最低级别');
                }
                else if(_this.addModel.max_level===''){
                    this.$Message.error('请选择最高级别');
                }
                else if(_this.addModel.company_id===''){
                    this.$Message.error('请选择承办单位');
                }
                else if(_this.is_pay==1 && _this.addModel.price===''){
                    this.$Message.error('请输入报名金额');
                }
                else if(_this.classDate.length===0){
                    this.$Message.error('请选择上课日期');
                }
                else if(_this.addModel.max_num===''){
                    this.$Message.error('请填写最多申报人数');
                }
                else{
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _url = '';
                    if(_this.addModel.class_id){
                        _url = 'editclass';
                    }else{
                        _url = 'addclass';
                    }
                    _this.addModel.start_date = _this.classDate[0];
                    _this.addModel.end_date = _this.classDate[1];
                    _this.$axios.post(_url,_this.addModel).then(res=>{
                        loading.close();
                        if(res.data.code==200){
                            _this.alertShow=false;
                            _this.getClassList(0);
                        }
                        else{
                            this.$Message.error(res.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            tandel(){
                this.alertShow=false;
            },
            getClassList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getclasslist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.start_date=res.data.data.start_date;
                        _this.end_date=res.data.data.end_date;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getClassList(0);
            },
            addClass(){
                let _this=this;
                _this.options3={
                    disabledDate (date){
                        return (date && date.valueOf() > new Date(_this.end_date).getTime()) || (date && date.valueOf() < new Date(_this.start_date).getTime() - 86400000);
                    }
                }
                _this.classDate=[],
                _this.addModel = {
                    class_id:'',
                    name:'',
                    dance_id:'',
                    min_level:'',
                    max_level:'',
                    max_num:'',
                    company_id:'',
                    start_date:'',
                    end_date:'',
                    price:'',
                };
                _this.addModel.term_id      = _this.searchModel.term_id;
                _this.alertShow=true;
            },
            getTea(){
                let _this=this; 
                _this.$axios.post('getteacherselect',{class_id:_this.class_id}).then(res=>{
                    if(res.data.code==200){
                        _this.teaList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getstatus(){
                let _this=this; 
                _this.$axios.post('getclassstatus',{}).then(res=>{
                    if(res.data.code==200){
                        _this.statusList=res.data.data;
                        _this.searchModel.status=res.data.data[0].id;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getcompany(){
                let _this=this; 
                _this.$axios.post('getcompanyselect',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getDanceList(index){
                let _this=this; 
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        _this.getLvel(index);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvel(index){
                let _this=this; 
                _this.$axios.post('getlevellist',{is_course:1}).then(res=>{
                    if(res.data.code==200){
                        if(index==1){
                            _this.levelArr=res.data.data;
                        }
                        else{
                            
                            _this.levelArr=res.data.data;
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvels(){
                let _this=this; 
                _this.getstatus();
                _this.$axios.post('getlevellist',{type:1,is_course:1}).then(res=>{
                    if(res.data.code==200){
                        _this.levelList=res.data.data;
                        _this.searchModel.level_id=res.data.data[0].id;
                        _this.getClassList(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.searchModel.term_id   = _this.$route.query.term_id;
            _this.term_name             = _this.$route.query.name;
            let searchData = JSON.parse(localStorage.getItem("searchData"+_this.searchModel.term_id));
            _this.getDanceList();
            _this.getcompany();
            if(searchData != null){
                _this.searchModel   = searchData;
                _this.getLvels(0);
            } else{
                _this.getLvels(0);
            }
            
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/teacher/ban.vue